import { BOOLEAN_STATUS } from '../models/processes.models';
import { IOperationOcrDetail } from '../models/processes.models';

/** Motivo KO de operación (`actions.KO`): visible si hay payload KO. */
export function shouldShowOperationKoReason(
	op?: { state?: string; actions?: { KO?: unknown } } | null,
): boolean {
	return !!op?.actions?.KO;
}

/**
 * Indica si un check antifraud debe mostrarse en UI o actividad.
 * Se basa solo en el status del check (NIF-819).
 */
export function shouldDisplayAntifraudCheck(
	_operationState: string | undefined,
	antifraudStatus: BOOLEAN_STATUS | string | undefined,
	options?: { showOnlyKo?: boolean; alwaysShowResult?: boolean },
): boolean {
	if (!antifraudStatus) {
		return false;
	}
	if (options?.showOnlyKo) {
		return antifraudStatus === BOOLEAN_STATUS.KO;
	}
	return true;
}

/** Algún check de comparación OCR (MRZ/AEAT/AML/PEP) visible. */
export function hasDisplayableOcrCompareAntifraud(ocr: IOperationOcrDetail | null | undefined): boolean {
	const antifraud = ocr?.antifraud;
	if (!ocr || !antifraud) {
		return false;
	}
	return (
		shouldDisplayAntifraudCheck(ocr.state, antifraud.MRZ_VALIDATE) ||
		shouldDisplayAntifraudCheck(ocr.state, antifraud.AEAT) ||
		shouldDisplayAntifraudCheck(ocr.state, antifraud.AML) ||
		shouldDisplayAntifraudCheck(ocr.state, antifraud.PEP)
	);
}
